import html2canvas from "html2canvas";
import { format } from "date-fns";

// The buttons below the page: screenshot of the page and report to whatsapp.
const useEditorFooterActions = ({ uiContext, headerData }) => {
  const handleScreenShot = async () => {
    const elementToHide = document.getElementById("excludeFromPrint");
    if (elementToHide) {
      elementToHide.style.display = "none";
    }

    setTimeout(async () => {
      try {
        const targetElement = document.body;
        const canvas = await html2canvas(targetElement, {
          scale: 2, // Higher scale means better quality, but larger file size
          useCORS: true, // Ensures cross-origin images are loaded properly
        });
        const image = canvas.toDataURL("image/png");

        let currentDate = new Date().toLocaleDateString("id-ID", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });

        const fileName = `${currentDate} ${headerData.data_kendaraan.nomor_polisi}.png`;

        const link = document.createElement("a");
        link.href = image;
        link.download = fileName;
        link.click();
      } catch (error) {
        uiContext.showErrorMsg("Error", "Screenshot capture failed");
        console.error("Screenshot capture failed:", error);
      } finally {
        if (elementToHide) {
          elementToHide.style.display = "";
        }
      }
    }, 100);
  };

  const handleLaporKeWhatsapp = () => {
    const currentHour = new Date().getHours();
    const greeting =
      currentHour < 12
        ? "Selamat Pagi"
        : currentHour < 15
        ? "Selamat Siang"
        : currentHour < 18
        ? "Selamat Sore"
        : "Selamat Malam";

    const currentUrlWithoutParams = window.location.href.split("?")[0];
    const dateTime = headerData.tanggal;
    const formattedDate = format(new Date(dateTime), "dd/MM/yyyy HH:mm:ss");

    let whatsappMessage = `${greeting} pak\n`;
    whatsappMessage += `Izin informasi.\n`;
    whatsappMessage += `Untuk Pemeriksaan Mobil \n`;
    whatsappMessage += `Tanggal/Waktu : ${formattedDate}\n\n`;
    whatsappMessage += `No.pol : ${headerData.data_kendaraan?.nomor_polisi}\n`;
    whatsappMessage += `Supir : ${headerData.data_supir?.nama} \n`;
    whatsappMessage += `Tujuan : ${headerData.data_tujuan?.nama} \n`;
    whatsappMessage += `NB: Kondisi mobil sesuai dengan data pemeriksaan yang ada di aplikasi \n\n`;
    whatsappMessage += `Link: ${currentUrlWithoutParams} \n\n`;
    whatsappMessage += `#Trims🙏`;

    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      whatsappMessage
    )}`;
    const whatsappLink = document.createElement("a");
    whatsappLink.href = whatsappUrl;
    whatsappLink.target = "_blank";
    whatsappLink.click();
  };

  return {
    handleScreenShot,
    handleLaporKeWhatsapp,
  };
};

export default useEditorFooterActions;
